import * as React from 'react';
import { DateTime } from 'ui';
import { createFormatters, createUTCDate, dateToUTC, parseAsDateUTC } from 'app/infrastructure/data/date';
import { CodeFieldWireKey } from 'app/area/indicator-factors/types-store';
import { CodeCodetablePickerProps } from 'app/area/indicator-factors/item/code-pickers/types';

export const ValidFrom = (props: CodeCodetablePickerProps) => {

  const { codeItem, translation, validation, locale, readOnly } = props;
  const codetableKey = CodeFieldWireKey.validFrom;

  const onChange = (value: Date) => {
    props.resetValidation(codetableKey, value);
    props.onChange(codetableKey, value);
    props.clearAllValidation(codetableKey);
  };

  const currentValidation = !!validation && !!validation[codetableKey] ? validation[codetableKey] : undefined;

  return <div className="col-lg-4 col-sm-12">
    <DateTime
      label={{ text: translation.validFrom, required: !readOnly }}
      useTime={false}
      value={codeItem && codeItem[codetableKey]}
      readOnly={readOnly}
      componentId={codetableKey}
      className="dateTime"
      parseDate={parseAsDateUTC}
      createDate={createUTCDate}
      cloneDate={dateToUTC}
      locale={locale}
      onChange={onChange}
      captionWrapper={'form'}
      validation={currentValidation}
      {...createFormatters(locale)}
    />
  </div>;
};
